import { Body1 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './AboutBuilding.css';
import { OptionalAnchor } from '../OptionalAnchor';

export interface IAboutBuildingProps {
  link?: string;
  name: string;
  onLinkClick(): void;
}

export const AboutBuilding: React.FC<IAboutBuildingProps> = ({ name, link, onLinkClick }) => {
  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();
    onLinkClick();
  };

  return (
    <OptionalAnchor href={link} className={styles['name']} onAnchorClick={handleLinkClick}>
      <Body1 color={link ? 'text-main-default' : undefined}>{name}</Body1>
    </OptionalAnchor>
  );
};
